import axios from 'axios'

const preferences = {
  setSize (category, size, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/limits',
      { 'username': localStorage.getItem('username'),
        'category': category,
        'size': size,
      },
      {'headers': 
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  setTtl (category, days, cb) {
    const promise = axios.post('https://api.psyco.fr/cafe/ttl',
      { 'username': localStorage.getItem('username'),
        'category': category,
        'days': days,
      },
      {'headers': 
        {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleRequest(promise, cb)
  },

  fetchAll (cb) {
    const promise = axios.get('https://api.psyco.fr/cafe/preferences', 
      {
        params: {username: localStorage.getItem('username')},
        headers: {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleResults(promise, cb)
  },

  handleResults(promise, cb) {
    promise.then((resp) => {
      if (resp.data.code && resp.data.code !== 200) {
        cb([])
      }
      else {
        cb(resp.data.data)
      }
    }).catch((error) => cb([]))
  },

  handleRequest (promise, cb) {
    promise.then((resp) => {
      cb(true)
    }).catch((error) => cb(false))
  },
}

export default preferences
